import ReactDOM from 'react-dom'
import Loadable from './Loadable'
import MyLoadable from './MyLoadable'

function makeLoadable(router, pluginHub) {
  router.routes = router.routes.map(route => {
    // 判断是否是异步加载组件 如果是则包装一下
    if (route.component && route.component.loader) {
      return {
        ...route,
        component: MyLoadable(route.component, pluginHub)
      }
    } else {
      return {
        ...route,
        component: route.component
      }
    }
  })
  router.NotFound = MyLoadable(router.NotFound, pluginHub)
  return router
}

export default (funkGoApp, router, { isServer = false, rootDomId = 'root' }) => {
  const rootDom = document.getElementById(rootDomId)
  const root = funkGoApp.renderRoot({ router: makeLoadable(router, funkGoApp.pluginHub) })

  if (isServer) {
    Loadable.preloadReady().then(() => {
      ReactDOM.hydrate(root, rootDom)
    })
  } else {
    ReactDOM.render(root, rootDom)
  }
}